import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { EmailTemplateType } from '@shared/models';
import { EmailTemplatesService } from '@shared/services';

import {
  rejectCandidateEmailTemplatesGet,
  rejectCandidateEmailTemplatesGetFailure,
  rejectCandidateEmailTemplatesGetSuccess,
} from './email-templates.actions';

@Injectable()
export class EmailTemplatesEffects {
  getApplicationHistory$ = createEffect(() => this.actions$.pipe(
    ofType(rejectCandidateEmailTemplatesGet),
    switchMap(() =>
      this.emailTemplateService.get({ params : { type: EmailTemplateType.CANDIDATE_REJECTION } })
        .pipe(
          map(emailTemplates => rejectCandidateEmailTemplatesGetSuccess({ emailTemplates })),
          catchError((error) => of(rejectCandidateEmailTemplatesGetFailure({ error }))),
        )
    )
  ));

  constructor(
    private actions$: Actions,
    private emailTemplateService: EmailTemplatesService,
  ) {}
}
